import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TThunkAction } from '../../types/redux/thunk';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { fetchOtp } from '../../repositories/otp/fetchOtp';
import { closeOtpModal } from '../otpModal/actions';
import { getFinanceMortgageUrl } from '../../services/getFinanceMortgageUrl';
import { trackRegister, trackAuth, trackRequestSuccess } from './tracking';

export enum EOtpActionTypes {
  ChangeOtp = 'OTP/ChangeOtp',
  ConfirmOtpRequest = 'OTP/ConfirmOtpRequest',
  ConfirmOtpSuccess = 'OTP/ConfirmOtpSuccess',
  ConfirmOtpError = 'OTP/ConfirmOtpError',
}

export const changeOtp = actionGenerator<EOtpActionTypes.ChangeOtp, string>(EOtpActionTypes.ChangeOtp);
export const confirmOtpRequest = actionGenerator<EOtpActionTypes.ConfirmOtpRequest>(EOtpActionTypes.ConfirmOtpRequest);
export const confirmOtpSuccess = actionGenerator<EOtpActionTypes.ConfirmOtpSuccess>(EOtpActionTypes.ConfirmOtpSuccess);
export const confirmOtpError = actionGenerator<EOtpActionTypes.ConfirmOtpError, string>(
  EOtpActionTypes.ConfirmOtpError,
);

export type TChangeOtp = ITypedReduxAction<EOtpActionTypes.ChangeOtp, string>;
export type TConfirmOtpRequest = ITypedReduxAction<EOtpActionTypes.ConfirmOtpRequest, void>;
export type TConfirmOtpSuccess = ITypedReduxAction<EOtpActionTypes.ConfirmOtpSuccess, void>;
export type TConfirmOtpError = ITypedReduxAction<EOtpActionTypes.ConfirmOtpError, string>;

export type TOtpActions = TChangeOtp | TConfirmOtpRequest | TConfirmOtpSuccess | TConfirmOtpError;

export const confirmOtp =
  (code: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    dispatch(confirmOtpRequest());

    const {
      trackLabel,
      phone: { uuid },
    } = getState();

    try {
      const res = await fetchOtp(context, { code, uuid });

      if (res.ok) {
        dispatch(confirmOtpSuccess());
        dispatch(closeOtpModal());
        const trackSuccess = trackRequestSuccess(trackLabel);

        if (res.isNewUser) {
          trackRegister();
        } else {
          trackAuth();
        }

        await trackSuccess();

        window.location.replace(
          getFinanceMortgageUrl({
            search: window.location.search,
          }),
        );
      } else if (res.error) {
        dispatch(confirmOtpError(res.error));
      }
    } catch (error) {
      context.logger.error(error);

      dispatch(confirmOtpError('Возникла ошибка во время отправки ОТП'));
    }
  };
